module.exports = __webpack_public_path__ + "static/media/redalert.8f120763.mp3";